import {nowString} from "./datetime-helpers";

class EventApi {

    constructor(seamApi) {
        this.api = seamApi;
    }


    async search({ page = 1, perPage = 20, term = '', from = nowString(), eventTypes = [] }) {
        return this.api.handleResponse(async () => {
            const response = await this.api.post('/events/search', { page, per_page: perPage, term, from, event_type_ids : eventTypes});
            return response.data;
        })
    }

    async get({ page = 1, perPage = 20, from = nowString(), eventTypes = [] }) {
        return  this.api.handleResponse(async () => {
            const response = await this.api.get('/events', { params : { page, per_page: perPage, from, event_type_ids : eventTypes, publish_at : nowString() }});
            return response.data;
        });
    }

    async types(page = 1, perPage = 20) {
        return this.api.handleResponse(async  () => {
            const response = await this.api.get('/event-types', { params : { page, perPage } });
            return response.data;
        });
    }


}


export default EventApi;
